import * as Types from './types';

const getPostingStatistics = postingId => ({
  type: Types.FETCH_POSTING_STATISTICS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/panel/api/v1/performance/getpostingstatistics`,
    method: 'GET',
    query: { postingId }
  }
});

const getPriceStatistics = postingId => ({
  type: Types.FETCH_PRICE_STATISTICS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/panel/api/v1/performance/getpricestatistics`,
    method: 'GET',
    query: { postingId }
  }
});

const fetchPerformanceStatus = postingId => {
  return {
    type: Types.FETCH_PERFORMANCE_STATUS,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v1/performance/getpostingperformancestatus`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const getBestPostingStatistics = postingId => ({
  type: Types.FETCH_BEST_POSTING_STATISTICS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/panel/api/v1/performance/getbestpostingstatistics`,
    method: 'GET',
    query: { postingId }
  }
});

export { getPostingStatistics, getPriceStatistics, fetchPerformanceStatus, getBestPostingStatistics };
